import React, { Component } from 'react'
import Responsive from './Responsive'
import { translate } from '../utils/useful'

export default class Intercommunication extends Component {
    state = {
        users: [
            { img: '/images/p1.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p2.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p3.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p4.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p5.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p6.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
            { img: '/images/p7.png', name: 'Nicolas Gorden', role: 'Senior Developer', phone: '+98 902 137 7118', email: 'mh.mohseni98@yonnect.com' },
        ]
    }
    render() {
        return (
            <div className='scroll-no-scrollbar h-100 window-content-radius'>
                <div className='bg-white' style={{ position: 'sticky', top: 0, zIndex: '2' }}>
                    <div className='flexcb mx-3 py-3'>
                        <div className='navbar-search py-2 px-3 br-10 w-100'>
                            <div className='d-flex flexcb'>
                                <input className="w-100" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder={translate('Search Users')} style={{ backgroundColor: 'transparent', }} />
                                <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                            </div>
                        </div>
                        <button className='flexcb br-10 mld-4 px-3' style={{ backgroundColor: '#f5f5f5', height: '38px' }}>
                            <p className='main-c7' style={{ whiteSpace: 'nowrap' }}>Sorth by: <span className='main-c5'>Last Updated</span></p>
                            <img width={20} src='/assets/icons/arrow-down-gray.svg' />
                        </button>
                    </div>
                </div>
                <div className='d-flex flex-wrap' >
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '12', 700: '12', 800: '10', lg: '10', xl: '11' }}>
                        <div className='d-flex flex-wrap mx-2 mb-2' style={{ zIndex: '1' }}>
                            {this.state.users.map((prop, index) => {
                                return (
                                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '4', lg: '3', xl: '2' }}>
                                        <div className='white-bg br-10 shadow-2 p-3 m-2'>
                                            <div className='flexcc flex-column'>
                                                <div className='flexcc' style={{ position: 'relative' }}>
                                                    <img className='br-50' width={50} src={prop.img} />
                                                    <div className='br-50 flexcc' style={{ backgroundColor: '#fff', width: '11px', height: '11px', position: 'absolute', bottom: 2, right: 2 }}>
                                                        <div className='br-50' style={{ backgroundColor: '#34C759', width: '8px', height: '8px' }}></div>
                                                    </div>
                                                </div>
                                                <p className='font-size-16 main-c2 weight-500 mt-1'>{prop.name}</p>
                                                <p className='font-size-12 main-c5'>{prop.role}</p>
                                                <div className='flexc mt-3'>
                                                    <img className='flexcc' width={18} src='/assets/icons/phone-gray.svg' />
                                                    <p className='font-size-10 main-c7'>{prop.phone}</p>
                                                </div>
                                                <div className='flexc mt-1'>
                                                    <img className='flexcc' width={18} src='/assets/icons/mail-gray.svg' />
                                                    <p className='font-size-10 main-c7'>{prop.email}</p>
                                                </div>
                                            </div>
                                            <div className='flexcc flex-column mt-5'>
                                                <button className='blue-btn w-100 br-30 py-2'>
                                                    <p>Connect</p>
                                                </button>
                                                <button className='blue-btn-border2 w-100 br-30 py-2 mt-2'>
                                                    <p>More</p>
                                                </button>
                                            </div>
                                        </div>
                                    </Responsive>

                                )
                            })}
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', 400: 'none', 700: 'none', 800: '2', lg: '2', xl: '1' }}>
                        <div className='flexcc flex-column bg-white br-10 p-3 shadow-2 mr-3 my-2'>
                            {/* <p className='font-size-12 weight-500 main-c4'>Recently been in Touch</p> */}
                            {this.state.users.map((prop, index) => {
                                return (
                                    <button className='flexcc flex-column mb-4'>
                                        <div className='flexcc' style={{ position: 'relative' }}>
                                            <img className='br-50' width={40} src={prop.img} />
                                            <div className='br-50 flexcc' style={{ backgroundColor: '#fff', width: '11px', height: '11px', position: 'absolute', bottom: 1, right: 1 }}>
                                                <div className='br-50' style={{ backgroundColor: '#34C759', width: '8px', height: '8px' }}></div>
                                            </div>
                                        </div>
                                        <p className='font-size-12 main-c2 weight-500 mt-1'>{prop.name}</p>
                                        <p className='font-size-10 main-c5'>{prop.role}</p>
                                    </button>

                                )
                            })}
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
